import {
  FETCH_FEATURE,
  FETCH_FEATURE_SUCCESS,
  FETCH_FEATURE_FAILURE,
} from '../actions'

const feature = (state = { }, action) => {
  switch (action.type) {
    case FETCH_FEATURE:
      return { ...state, loading: true }
    case FETCH_FEATURE_SUCCESS:
      return { ...action.feature}
    case FETCH_FEATURE_FAILURE:
      return {
        loading: false,
        error: action.error
      }
    default:
      return state;
  }
}

export default feature



// WEBPACK FOOTER //
// ./src/reducers/feature.js